var map = {
	"./about-2.png": "c411",
	"./batman.gif": "1a47",
	"./header.jpg": "6b2a",
	"./introduction.jpg": "9c8e",
	"./logo.png": "cf05",
	"./pikachu.gif": "3a18",
	"./tailwind.css": "ba8c",
	"./whyChooseUs.png": "a9e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";